import React from 'react';
import ActionCell, { ActionButtonLink } from 'App/components/styles/ActionCell';

const ActionGroupCell = (index, noteObject, editNote, setNoteToDelete, isFormOpen) => {
    return (
        <ActionCell>
            <ActionButtonLink onClick={() => editNote(noteObject)} disabled={isFormOpen}>
                View/Edit
            </ActionButtonLink>
            <ActionButtonLink onClick={() => setNoteToDelete({ ...noteObject, index })}>Delete</ActionButtonLink>
        </ActionCell>
    );
};

export default ActionGroupCell;
